:root {
  --White-Gradient: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 60%,
    #ffffff 100%
  );
  --Grey-Gradient: linear-gradient(
    180deg,
    rgba(237, 241, 244, 0) 0%,
    rgba(237, 241, 244, 0.5) 60%,
    #edf1f4 100%
  );
  --Blue-Gradient: linear-gradient(
    180deg,
    rgba(0, 43, 73, 0) 0%,
    rgba(0, 43, 73, 0.5) 60%,
    #002b49 100%
  );
}

:host {
  --header-height: 56px;
  --header-host-height: 56px;
  --header-max-width: 1920px;
  display: flex;
  justify-content: center;
  height: var(--header-host-height);
}
@media (min-width: 768px) {
  :host {
    --header-height: 80px;
    --header-host-height: 80px;
  }
}
@media (min-width: 1200px) {
  :host {
    --header-host-height: 128px;
  }
}
@media (max-width: 1920px) {
  :host {
    --header-max-width: 1440px;
  }
}

.header-wrapper {
  display: grid;
  grid-auto-flow: row;
  margin: 0 auto;
  background-color: #ffffff;
  box-shadow: 0px 16px 24px -4px rgba(0, 43, 73, 0.12);
  max-width: min(100vw, var(--header-max-width));
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  transition: transform 0.3s ease-in-out;
}
.header-wrapper.header--hidden {
  transform: translateY(-100%);
}
.header-wrapper .header-main-nav-wrapper {
  height: 0;
  max-width: min(100vw, var(--header-max-width));
}
@media (min-width: 1200px) {
  .header-wrapper .header-main-nav-wrapper {
    height: auto;
  }
}